const switches = [
  {
    name: 'geographic_spread',
    key: 'geographic_spread',
    label: 'Geographic Spread',
    tab: 'feed',
  },
  {
    name: 'accuracy',
    key: 'accuracy',
    label: 'Accuracy',
    tab: 'feed',
  },
  {
    name: 'last_updated',
    key: 'last_updated',
    label: 'Last Updated',
    tab: 'feed',
  },
  {
    name: 'frequency',
    key: 'frequency',
    label: 'Frequency',
    tab: 'feed',
  },
  {
    name: 'contribution',
    key: 'contribution',
    label: 'Contribution',
    tab: 'feed',
  },
  {
    name: 'correlation',
    key: 'correlation',
    label: 'Correlation',
    tab: 'feed',
  },
  {
    name: 'asn_takedown_reputation',
    key: 'asn_takedown_reputation',
    label: 'As Takedown Reputation',
    tab: 'ip',
  },
  {
    name: 'asn_rank',
    key: 'asn_rank',
    label: 'ASN Rank',
    tab: 'ip',
  },

  {
    name: 'ns_avg_ttl',
    key: 'ns_avg_ttl',
    label: 'NS Average TTL',
    tab: 'domain',
  },
  {
    name: 'is_new',
    key: 'is_new',
    label: 'Is New',
    tab: 'domain',
  },
  {
    name: 'age',
    key: 'age',
    label: 'Age',
    tab: 'domain',
  },
  {
    name: 'is_dynamic_domain',
    key: 'is_dynamic_domain',
    label: 'Is Dynamic Domain',
    tab: 'domain',
  },
  {
    name: 'avg_probability',
    key: 'avg_probability',
    label: 'Average Probability',
    tab: 'domain',
  },
  {
    name: 'is_url_shortener',
    key: 'is_url_shortener',
    label: 'Is URL Shortener',
    tab: 'domain',
  },
  {
    name: 'customer_domain',
    key: 'customer_domain',
    label: 'Similarity to customer domain',
    tab: 'custom',
  },
  {
    name: 'top_brand',
    key: 'top_brand',
    label: 'Similarity to top brand',
    tab: 'custom',
  },
  {
    name: 'geo_ip',
    key: 'geo_ip',
    label: 'GEO',
    tab: 'custom',
  },
  {
    name: 'ip_range_weight',
    key: 'ip_range_weight',
    label: 'IP Range',
    tab: 'custom',
  },
];

export default switches;
